<div
  class="basin-height-100 width-400 basin-background-true-white basin-overflow-y-auto basin-px-4 basin-py-5"
>
  <!-- Title -->
  <div class="basin-display-flex basin-align-items-center basin-mb-4">
    <h5>
      Simulation Results
    </h5>
    <span class="symbol-info basin-ml-1 basin-color-light-gray" pTooltip="These are the results of a completed simulation. To run a new simulation, please go to the Predictor Page."></span>
  </div>
  <div class="basin-display-flex basin-align-items-center basin-justify-content-space-between">
    <h6>
      {{ (selectedStudyArea$ | async)?.studyAreaName || "Study Areas" }}
    </h6>
    <div
      *ngIf="(selectedStudyArea$ | async)?.hasTerrain"
      class="symbol-landscape-2 outlined basin-color-blue"
      pTooltip="Terrain File Uploaded"
    ></div>
  </div>

  <!-- Study Area Details -->
  <div *ngIf="selectedStudyArea$ | async; let studyArea">
    <app-study-area-details [studyArea]="studyArea"></app-study-area-details>
  </div>

  <!-- Tracker Details -->
  <ng-container *ngIf="selectedStudyArea$ | async as studyArea">
    <div class="basin-pb-2">
      <app-simulation-tracker-details
        [simulationTracker]="simulationTracker$ | async"
      ></app-simulation-tracker-details>
    </div>
  </ng-container>

  <div
    class="basin-pt-2"
    *ngIf="(scenarios$ | async) && (scenarios$ | async)!.length > 0"
  >
    <label for="scenarios">Select Scenarios</label>
    <p-dropdown
      id="scenarios"
      [filter]="true"
      filterBy="scenario"
      optionLabel="scenario"
      styleClass="basin-width-100"
      [options]="(scenarios$ | async) ?? []"
      [(ngModel)]="selectedSimulationTracker"
      (onChange)="trackerChange($event)"
      placeholder="Change Scenario"
      [optionDisabled]="'disabled'"
      scrollHeight="350px"
      #dropdown
    >
      <ng-template pTemplate="selectedItem" let-selectedOption>
        <div>Scenario {{ selectedOption?.scenario || "" }}</div>
      </ng-template>

      <ng-template let-tracker pTemplate="item">
        <basin-list-item [primaryLine]="'Scenario ' + tracker.scenario">
          <div
            rightSection
            class="p-d-flex p-jc-center p-ai-center basin-color-blue basin-height-100"
          >
            <basin-tag
              [value]="getStatus(tracker.status)"
              [theme]="getStatusTheme(tracker.status)"
              [icon]="getStatusIcon(tracker.status)"
            ></basin-tag>
          </div>
        </basin-list-item>
      </ng-template>
    </p-dropdown>
  </div>

  <p-divider></p-divider>

  <div>
    <div class="basin-subtitle basin-pb-2">Simulation Details</div>

    <app-simulation-tracker-details-list
      [simulationTracker]="simulationTracker$ | async"
    ></app-simulation-tracker-details-list>
  </div>

  <ng-container
    *ngIf="(simulationTracker$ | async)?.status === trackerStatus.Completed"
  >
    <p-divider></p-divider>

    <div>
      <div class="basin-subtitle">Export</div>

      <app-export-section
        [results]="true"
        [resultsSimulationId]="resultsSimulationId"
      ></app-export-section>
    </div>
  </ng-container>

  <ng-container *ngIf="agentSettings$ | async as agentSettings">
    <p-divider></p-divider>

    <div>
      <div class="basin-subtitle basin-pb-2">Agent Settings</div>
      <app-agent-settings-list
        [agentSettings]="agentSettings$ | async"
      ></app-agent-settings-list>
    </div>
  </ng-container>
</div>
